export function getGoogleMapsLink(store) {
    if (store.googleMapsLink !== "")
        return store.googleMapsLink;
    return `https://www.google.com/maps?q=${encodeURI(`${store.address1} ${store.city} ${store.postalCode} ${store.province} ${store.country.name}`)}`;
}
